/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise'
import type { BaseHttpRequest } from '../core/BaseHttpRequest'
import type { MessagingRunsSummary } from '../models/MessagingRunsSummary'

export class MessagingRunsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * The email and SMS senders' live state, from the reports their send runs make. Read from cache
     * only; the Helm page loads it, polls it, and also gets it pushed on each run.
     * The email and SMS senders' live state, built from the reports each send run makes to the api (one when it claims its batch, one when it ends). Kept only in cache and read without touching the database, so it's cheap to poll; the same object is pushed on the private `Helm.Messaging.Runs` channel (event `MessagingRunRecorded`, as `summary`) whenever a run reports.
     *
     * Per queue (`email`, `sms`):
     * - `last_reported_at`: when any run of this queue last reported. A sender runs every minute and reports even when there's nothing to send, so an old value means it isn't running (or can't reach the api).
     * - `last_run`: the latest run to end - `ended` is `finished`, or `died` when it stopped early (a PHP fatal, an uncaught error, or a database error), with `error`.
     * - `runs_last_5_minutes`, `sent_last_5_minutes`: runs that ended, and messages they sent, in the last five minutes.
     * - `unfinished_runs`: runs that claimed a batch and haven't ended. Normal while a run is going; one that's been unfinished far longer than a run takes was killed, and its unsent messages are stuck.
     * - `died_runs`: the latest runs that died, with their errors.
     * - `not_sent`: the most common outcomes other than sent, over runs in the last hour - the status a message was left in plus any error message (provider errors, limits, blocks), phone numbers and email addresses replaced.
     *
     * `counted_at` is when this was read.
     * @returns any OK
     * @throws ApiError
     */
    public getMessagingRuns(): CancelablePromise<{ data: MessagingRunsSummary }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/messaging/runs',
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }
}
